<template>

  <!-- Slides Gallery Element -->
  <q-carousel-slide
    :name="name"
    :style="styles"
    class="slides-gallery-element"
    :class="{[value.textAlign]: value.textAlign}">

    <page-block
      no-body
      :bg-file="bgFile"
      :bg-color="bgColor"
      :bg-opacity="value.bgOpacity"
      :text-align="value.textAlign"
      class="slides-gallery-element__block"
      :text-color="value.textColor || '#FFFFFF'"
      overlay-class="slides-gallery-element__overlay"
      wrapper-class="slides-gallery-element__wrapper">

      <vue-plyr
        class="absolute-full"
        v-if="fileType === 'video'">

        <video
          :src="getFileUrl(value.file)"/>

      </vue-plyr>

      <div
        class="slides-gallery-element__body">

        <div
          v-html="$u.localize(value.title)"
          class="slides-gallery-element__title"
          v-if="$u.stripTags($u.localize(value.title))"/>

        <div
          v-html="$u.localize(value.body)"
          class="slides-gallery-element__subtitle"
          v-if="$u.stripTags($u.localize(value.body))"/>

        <page-block-buttons
          :value="value.buttons"
          class="slides-gallery-element__buttons"/>

      </div>

    </page-block>

  </q-carousel-slide>

</template>

<script>

  import {simpleFileType} from '@src/utils';
  import PageBlock from 'components/page/page-block';
  import PageBlockButtons from 'components/page/page-block-buttons';

  export default {
    name: 'slides-gallery-element',
    props: {
      value: {
        type: Object,
        required: true,
      },
      name: {
        type: Number,
        required: true,
      },
    },
    components: {
      PageBlock,
      PageBlockButtons,
    },
    computed: {
      styles() {

        return this.value.file
          ? {backgroundColor: this.bgColor}
          : {};
      },
      bgFile() {

        return this.fileType !== 'video'
          ? this.value.file
          : undefined;
      },
      bgColor() {

        return this.value.bgColor
          || '#4C4477';
      },
      fileType() {

        return this.value.file
          && simpleFileType(this.value.file);
      },
    },
  };

</script>

<style lang="scss">

  $cls: slides-gallery-element;

  .slides-gallery-element {
    color: inherit;

    &__block,
    &__overlay {
      @include abs-fill;
    }

    &__wrapper {
      height: 100%;
      display: flex;
    }

    &.right {

      .#{$cls}__wrapper {
        justify-content: flex-end;
      }
    }

    &.center {

      .#{$cls}__wrapper {
        justify-content: center;
      }
    }

    &__body {
      display: flex;
      max-width: 70%;
      position: relative;
      flex-direction: column;
      justify-content: center;
      padding: $ibs-y ($ibs-x * 3);

      @media (max-width: $breakpoint-sm) {
        max-width: none;
        padding-left: $bs-x;
        padding-right: $bs-x;
      }

      @media (max-width: $breakpoint-xs) {
        padding-left: $ibs-x;
        padding-right: $ibs-x;
      }

      p:last-child {
        margin-bottom: 0;
      }
    }

    &__title {
      font-weight: 600;
      line-height: 1.2em;
      font-size: map-get($h1, size);

      @media (max-width: $breakpoint-sm) {
        font-size: map-get($h2, size);
      }

      @media (max-width: $breakpoint-xs) {
        font-size: map-get($h3, size);
      }
    }

    &__subtitle {
      font-weight: 500;
      margin-top: $spacer-md;
      font-size: map-get($h4, size);

      @media (max-width: $breakpoint-sm) {
        margin-top: $spacer-mm;
        font-size: map-get($h6, size);
      }
    }

    &__buttons {
      margin-top: $spacer-md;

      @media (max-width: $breakpoint-sm) {
        margin-top: $spacer-sm;
      }

      & > * {
        display: block;
      }

      button {
        min-width: 60%;
      }

      .q-btn__wrapper {
        color: white;
        min-width: 100%;
      }
    }
  }

</style>
